module.exports = __webpack_public_path__ + "img/copy-third.8327db74.svg";